<template>
  <div class="lead-alerts lead-alerts__text d-flex justify-content-center align-items-center flex-md-column flex-xl-row">
    <span
      v-b-tooltip.hover
      class="d-flex justify-content-center w-100"
      :title="!control ? $t('Your account is closed'): ''"
    >
      {{ $t('Lead Alerts:') }}
      <b-form-checkbox
        v-model="tempStatus"
        switch
        :class="{'ml-2': true, 'white': variant === 'light'}"
        :disabled="!control"
        @change="askConfirmation"
      />
    </span>
    <b-modal ref="confirmationModal" centered @ok="confirmStatusChange" @hide="onModalHide">
      <p class="my-4">
        {{ $t('enableOrDisableLeadAlerts', {enableOrDisable: action}) }}
      </p>
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t('Confirmation') }}
        </h5>
        <b-button class="close" @click.stop="close">
          <font-awesome-icon icon="times" />
        </b-button>
      </template>
      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="outline-secondary" @click.stop="cancel()">
          {{ $t('Cancel') }}
        </b-button>
        <b-button size="sm" variant="primary" @click.stop="ok()">
          {{ $t('OK') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "LeadAlerts",
  props: ['variant'],
  data() {
    return {
      tempStatus: null,
    }
  },
  computed: {
    action: function() {
      return this.tempStatus ? this.$t('enable'): this.$t('disable');
    },
    status: function() {
      return this.$store.state.leads.LEAD_ALERT_STATUS;
    },
    control: function() {
      return this.$store.state.leads.LEAD_ALERT_CONTROL;
    }
  },
  methods: {
    confirmStatusChange: function () {
      this.$store.dispatch('changeAlertStatus', this.tempStatus);
    },
    onModalHide: function(e) {
      if (e.trigger !== 'ok') {
        this.tempStatus = !this.tempStatus;
      }
      this.$nextTick(() => this.$emit('modal-closed'));
    },
    askConfirmation() {
      this.$emit('modal-opened');
      this.$refs.confirmationModal.show();
    },
  },
  watch: {
    status: function() {
      this.tempStatus = this.status;
    }
  },
  mounted() {
    this.tempStatus = this.status;
  },
}
</script>

<style scoped lang="scss">
.lead-alerts{
    .white {
      height: 24px;
    }
}
</style>
